module.exports = __webpack_public_path__ + "images/ext-link-blue.5d12e5fb7c.svg";